export default "__VITE_PUBLIC_ASSET__24e286c3__"